import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { cookieService } from "../services";
import ProductAddReviewModal from './ProductAddReviewModal';
import ProductReviewsRatingItem from './ProductReviewsRatingItem';
import StarRating from './StarRating';
import { getReviewsSummary } from '../actions/reviews.actions';
import LoginModal from './tailwind/LoginModal';
import classNames from 'classnames';
import CookieNames from '../constants/cookie-names.constants';
import { Link } from '@components/Link';

const ProductReviewsRating = ({ mode = 'v1', listUrl, variants }) => {
  const dispatch = useAppDispatch();

  const { details } = useSelector((state) => state.pdpItem);
  const { totalCount, ratings, rating, typeId: summaryTypeId } = useSelector((state) => state.reviewsSummary);

  const loginModalRef = useRef(null);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [addReviewModal, setAddReviewModal] = useState(false);

  useEffect(() => {
    if (details && details.attributes.typeId !== summaryTypeId) {
      dispatch(getReviewsSummary(details.attributes.typeId));
    }
  }, [dispatch, details]);

  const toggleModalHandler = useCallback(() => {
    if (addReviewModal) {
      document.body.classList.remove('no-scroll');
      setAddReviewModal(false);
    } else {
      if (cookieService.get(CookieNames.NAME)) {
        document.body.classList.add('no-scroll');
        setShowLoginModal(false);
        setAddReviewModal(true);
      } else if (showLoginModal) {
        loginModalRef.current.openModal();
      } else {
        setShowLoginModal(true);
      }
    }
  }, [addReviewModal, loginModalRef, showLoginModal]);

  return (
    <div id='ProductReviewsRating'>
      <div className='row'>
        <div className='col-12'>
          {mode === 'v2' && (
            <p className='review-rating-avg'>
              {rating}
              <small>based on</small>
            </p>
          )}

          <StarRating reviewRating={rating} reviewCount={totalCount} showReviewLabel isLarge />

          <div className='review-rating'>
            {ratings.map((r) => (
              <ProductReviewsRatingItem
                key={r.rating}
                reviewCount={r.count}
                score={(r.count / totalCount) * 100}
                label={r.rating}
              />
            ))}
          </div>

          <div className={classNames({ 'text-center': mode === 'v2' })}>
            {mode === 'v2' && listUrl && (
              <Link href={`/reviews${listUrl}`} className='reviews-read-all'>
                Read all {totalCount} reviews
              </Link>
            )}

            <button onClick={toggleModalHandler} className='plum-btn'>
              Write A review
            </button>
          </div>
          {showLoginModal ? (
            <LoginModal defaultShown ref={loginModalRef} className='plum-modal' dismissBtnText='Cancel' />
          ) : (
            addReviewModal && <ProductAddReviewModal variants={variants} toggleHandler={toggleModalHandler} />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(ProductReviewsRating);
